export async function syncGlobalCollections(userName, options = {}, deps = {}) {
  const {
    DB,
    GLOBAL_COLLECTIONS = [],
    GLOBAL_SYNC_FRESHNESS_MS = 0,
    GLOBAL_KEY = (value) => value,
    pullGlobal,
    pushGlobal,
    dedupeCollectionForBootstrap,
    collectionItemsReferSameIdentity,
    choosePreferredCollectionItem,
    windowObj = typeof window !== "undefined" ? window : null,
  } = deps || {};

  if (!DB || typeof pullGlobal !== "function" || typeof pushGlobal !== "function" || typeof dedupeCollectionForBootstrap !== "function" || typeof collectionItemsReferSameIdentity !== "function" || typeof choosePreferredCollectionItem !== "function") {
    throw new Error("syncGlobalCollections missing dependencies");
  }

  const collections = Array.isArray(options.collections) && options.collections.length
    ? options.collections
    : GLOBAL_COLLECTIONS;
  const freshnessMs = Number(options.freshnessMs || GLOBAL_SYNC_FRESHNESS_MS || 0);
  const skipFresh = options.skipFresh !== false;

  await Promise.all(collections.map(async (col) => {
    const key = GLOBAL_KEY(col);
    try {
      if (skipFresh && freshnessMs > 0) {
        const warmedAt = Number((await DB.get(`${key}:_warmAt`)) || 0);
        if (warmedAt && (Date.now() - warmedAt) < freshnessMs) return;
      }
      const srv = await pullGlobal(key, userName);
      if (!srv?.data) return;
      const srvVer = srv.version || 0;
      const locVer = (await DB.get(`${key}:_ver`)) || 0;
      if (srvVer > locVer) {
        const locData = await DB.get(key);
        const srvArr = Array.isArray(srv.data) ? srv.data : [];
        const locArr = Array.isArray(locData) ? locData : [];
        const merged = dedupeCollectionForBootstrap([...(locArr || []), ...(srvArr || [])], col).map((item) => {
          const localMatch = locArr.find((candidate) => collectionItemsReferSameIdentity(candidate, item, col));
          const serverMatch = srvArr.find((candidate) => collectionItemsReferSameIdentity(candidate, item, col));
          return choosePreferredCollectionItem(localMatch, serverMatch, col);
        });
        await DB.set(key, merged);
        await DB.set(`${key}:_ver`, srvVer);
        await DB.set(`${key}:_warmAt`, Date.now());
        windowObj?.dispatchEvent?.(new CustomEvent("fz:sync:updated", { detail: { key } }));
      } else if (srvVer === 0) {
        const locData = await DB.get(key);
        if (locData && Array.isArray(locData) && locData.length > 0) {
          const res = await pushGlobal(key, locData, userName);
          if (res?.version) await DB.set(`${key}:_ver`, res.version);
        }
        await DB.set(`${key}:_warmAt`, Date.now());
      } else {
        await DB.set(`${key}:_warmAt`, Date.now());
      }
    } catch (e) {}
  }));
}
